import { createReducer, on } from '@ngrx/store';
import { TestActions } from './test.action';

export const initialState: any = [];

export const testReducer = createReducer<any>(
  initialState,
  on(TestActions.addTestResults, (state, { payload }) => ({
    ...state,
    ...payload,
  }))
);
